module.exports = __webpack_public_path__ + "static/img/bg_02.def5366.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_02.png
// module id = SJ6k
// module chunks = 3